import { AdminPageContent } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { ClauseChecklistsTable } from "./components/clause-checklists-table/ClauseChecklistsTable";
import { DraftCards } from "./components/DraftCards";

const AdminClauseChecklists = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Checklists");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Checklists" },
        ]);
    });

    return (
        <AdminPageContent>
            <DraftCards />
            <ClauseChecklistsTable />
        </AdminPageContent>
    );
};

export default AdminClauseChecklists;
